export default {
  get: (client, params) => client.$get('search', { params })
}